import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { AdsUser } from 'src/app/classes/ads-user';
import UserTypes from 'src/app/constants/user-types';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})

export class UsersComponent implements OnInit {  
  adsUsers: AdsUser[] = []

  userTypes = UserTypes

  constructor(
    private userService: UserService
  ) { }
  
  ngOnInit(): void {
    this.userService.search({}).subscribe(adsUsers => {
      this.adsUsers = adsUsers
    })
  }
}
